import { LANG_TYPE } from "./constant";

// FE: en zh de
// BE: en zh-Hans de
export function getUsedLang(isInit: boolean = false, isUsedForBE: boolean = false, browserLang: string | null = null): string {
    if (!localStorage.getItem('lang') && isInit) {
        const usedLang = (browserLang == LANG_TYPE.DE) ? LANG_TYPE.DE : LANG_TYPE.EN;

        localStorage.setItem('lang', usedLang)
        return usedLang
    }
    if (localStorage.getItem("lang") == LANG_TYPE.ZH) {
        return isInit ? LANG_TYPE.EN : (isUsedForBE ? LANG_TYPE.ZH_HANS : LANG_TYPE.ZH)
    }
    return localStorage.getItem("lang") || LANG_TYPE.EN
}

function deepClone(obj: any) {
    // Create a new object to store the cloned object
    let objClone: any = Array.isArray(obj) ? [] : {};
    // Check if the object is an array or an object
    if (obj && typeof obj === 'object') {
      // Loop through the object
      for (let key in obj) {
        // Check if the object is an object
        if (obj[key] && typeof obj[key] === 'object') {
          // If it is an object, call the deepClone function
          objClone[key] = deepClone(obj[key]);
        } else {
          // Otherwise, assign the value of the original object to the cloned object
          objClone[key] = obj[key];
        }
      }
    }
    // Return the cloned object
    return objClone;
  }

  export { deepClone }